import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_VMS_AZURE_IMAGES,
  GET_VMS_AZURE_IMAGES_SUCCESS,
  GET_VMS_AZURE_IMAGES_ERROR,
} from "./constant";

import { getAzureVmsImagesApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureVmsImagesList(params) {
  try {
    const data = yield call(getAzureVmsImagesApi, params);
    yield put({ type: GET_VMS_AZURE_IMAGES_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_VMS_AZURE_IMAGES_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureVmsImagesSaga() {
  yield takeLatest(GET_VMS_AZURE_IMAGES, getAzureVmsImagesList);
}
